import { render } from "./CategoryItemModal.vue?vue&type=template&id=fe3b2e58&lang=pug"
import script from "./CategoryItemModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoryItemModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__